// extracted by mini-css-extract-plugin
export default {"Cards":"cards_Cards__YP04R","parentContainer":"cards_parentContainer__THY9J"};